<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  background-color: #f8f9fa;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}


/* --- SNOTIFY MODERN SAAS INDIGO --- */

/* Conteneur principal */
.snotify {
  width: 350px !important;
}

/* Style de base du Toast */
.snotifyToast {
  background-color: #ffffff !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid #e2e8f0 !important; /* Slate 200 */
  margin-bottom: 10px !important;
}

/* Texte : Titre */
.snotifyToast__title {
  color: #1e293b !important; /* Slate 800 */
  font-weight: 700 !important;
  font-size: 14px !important;
  margin-bottom: 2px !important;
}

/* Texte : Corps */
.snotifyToast__body {
  color: #64748b !important; /* Slate 500 */
  font-size: 13px !important;
  font-weight: 400 !important;
}

/* Barre de progression ultra-fine */
.snotifyToast__progressBar {
  height: 3px !important;
  background-color: #e2e8f0 !important;
}

.snotifyToast__progressBar__percentage {
  background-color: #4f46e5 !important; /* Indigo principal */
}

/* Variantes par Type (Bordure latérale) */

/* SUCCESS */
.snotify-success {
  border-left: 5px solid #10b981 !important; /* Emerald 500 */
}
.snotify-success .snotifyToast__progressBar__percentage {
  background-color: #10b981 !important;
}
.snotify-success .snotifyToast__inner {
  padding-left: 15px;
}

/* ERROR */
.snotify-error {
  border-left: 5px solid #ef4444 !important; /* Red 500 */
}
.snotify-error .snotifyToast__progressBar__percentage {
  background-color: #ef4444 !important;
}

/* WARNING */
.snotify-warning {
  border-left: 5px solid #f59e0b !important; /* Amber 500 */
}
.snotify-warning .snotifyToast__progressBar__percentage {
  background-color: #f59e0b !important;
}

/* Style des icônes (monochrome et discret) */
.snotifyToast__icon {
  filter: grayscale(100%) brightness(50%);
  opacity: 0.6;
  max-width: 20px;
}

/* Suppression du bouton close par défaut pour un look plus propre */
.snotifyToast__buttons {
  display: none;
}
</style>
